import { useMemo, useState } from 'react';

import { isValid, parse } from 'date-fns';

const normalizeValueForCompare = (value) => {
  if (value === null || value === undefined) return '';
  const parsedValue = parse(value, 'dd.MM.yyyy', new Date());
  if (parsedValue) {
    if (isValid(parsedValue)) {
      return parsedValue;
    }
  }
  return String(value);
};

export const useSortedItems = (items) => {
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });

  const updateSorting = (columnKey) => {
    if (columnKey === sortConfig.key) {
      if (sortConfig.direction === 'asc') {
        setSortConfig({ key: columnKey, direction: 'desc' });
        return;
      }
      if (sortConfig.direction === 'desc') {
        setSortConfig({ key: '', direction: '' });
        return;
      }
    }
    setSortConfig({ key: columnKey, direction: 'asc' });
  };

  const sortedItems = useMemo(() => {
    if (!Array.isArray(items)) return items;
    const key = sortConfig && sortConfig.key;
    const direction = sortConfig && sortConfig.direction;

    if (!key || !direction) return items;

    const sorted = [...items].sort((a, b) => {
      const aVal = normalizeValueForCompare(a[key]);
      const bVal = normalizeValueForCompare(b[key]);
      const aIsDate = isValid(aVal);
      const bIsDate = isValid(bVal);

      if (aIsDate && bIsDate) {
        if (direction === 'asc') return aVal.getTime() - bVal.getTime();
        return bVal.getTime() - aVal.getTime();
      }
      if (!aIsDate && bIsDate) {
        if (direction === 'asc') return 1;
        return -1;
      }
      if (!bIsDate && aIsDate) {
        if (direction === 'asc') return -1;
        return 1;
      }

      if (direction === 'asc') return aVal.localeCompare(bVal);
      return bVal.localeCompare(aVal);
    });

    return sorted;
  }, [items, sortConfig && sortConfig.key, sortConfig && sortConfig.direction]);
  return [sortedItems, sortConfig, setSortConfig, updateSorting];
};
